


import { createAction as ngrxCreateAction, props, Action } from '@ngrx/store';

export const INIT_SCREEN = '[Master visualizarUsuario] Init';
export const DESTROY_SCREEN = '[Master visualizarUsuario] Destroy';

export const INIT_STATE = '[Master visualizarUsuario] Init State';
export const INIT_VALUE = '[Master visualizarUsuario] Init Value';
export const INIT_VALUE_SUCCESS = '[Master visualizarUsuario] Init Value Success';
export const INIT_VALUE_FAIL = '[Master visualizarUsuario] Init Value Fail';
export const UPDATE_DATA = "[Master visualizarUsuario] Update Data";

    export const FECHAR = '[Master visualizarUsuario] Fechar';
export const FECHAR_SUCCESS = '[Master visualizarUsuario] Fechar Success';
export const FECHAR_FAIL = '[Master visualizarUsuario] Fechar Fail';



export const initAction = ngrxCreateAction(INIT_SCREEN, payload => payload);

export const destroyAction = ngrxCreateAction(DESTROY_SCREEN, payload => payload);

  // Fechar action
export const fecharAction = ngrxCreateAction(FECHAR,payload => payload);

export const fecharSuccessAction = ngrxCreateAction(FECHAR_SUCCESS,payload => payload);

export const fecharFailAction = ngrxCreateAction(FECHAR_FAIL, payload => payload);


export const initStateAction = ngrxCreateAction(INIT_STATE,payload => payload);

export const initValueAction = ngrxCreateAction(INIT_VALUE,payload => payload);

export const initValueSuccessAction = ngrxCreateAction(INIT_VALUE_SUCCESS,payload => payload);

export const initValueFailAction = ngrxCreateAction(INIT_VALUE_FAIL,payload => payload);

export const updateDataAction = ngrxCreateAction(
    UPDATE_DATA,
    payload => payload
  );


